import useSendSeenAdv from '../../hooks/useSendSeenAdv'
import useTrackContactAdvisorSubmit from '../../hooks/useTrackContactAdvisorSubmit'
import useTrackPageLoad from '../../hooks/useTrackPageLoad'

const MatchScreenTracking = (): null => {
  useSendSeenAdv()
  useTrackContactAdvisorSubmit()
  useTrackPageLoad()

  return null
}

export default MatchScreenTracking
